import { useQuery, useMutation } from 'react-query'
import graphQLRequest from 'CanExConfig/graphQLRequest'
import { FETCH_CANDIDATE_PROFILE, UPDATE_CANDIDATE_REGIONAL_CITIZENSHIP } from './candidateProfile'

export const CITIZENSHIP_KEY = 'candidateProfileCitizenships'

const fetchCandidateProfile = candidateId => graphQLRequest(FETCH_CANDIDATE_PROFILE, { candidateId })
const updateCandidateProfile = props => graphQLRequest(UPDATE_CANDIDATE_REGIONAL_CITIZENSHIP, props)

export const useFetchCandidateProfile = ({ enabled, candidateId }) => {
  const { data: { candidateProfile } = {}, isLoading } = useQuery(
    [CITIZENSHIP_KEY, candidateId],
    () => fetchCandidateProfile(candidateId),
    { enabled },
  )

  return { isLoading, candidateProfile }
}

export const useMutateCandidateProfile = () => useMutation('updateCitizenship', props => updateCandidateProfile(props))
